export const initNavigation = () => {
    const pages = document.querySelectorAll('.page');
    const navigateToHash = (hash) => {
        const targetComponent = document.querySelector('.component[data-identifier="' + hash + '"]');
        if (targetComponent) {
            scrollToComponent(targetComponent);
            return;
        }
        const targetPage = document.querySelector('#page-' + hash);
        if (targetPage) {
            activateTargetPage(targetPage);
        }
    };
    const activateTargetPage = (targetPage) => {
        pages.forEach((page) => {
            page.classList.toggle('active', page === targetPage);
            page.classList.toggle('inactive', page !== targetPage);
        });
        if (typeof targetPage.dataset['product'] === 'string') {
            window.page.product = targetPage.dataset['product'];
        }
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    };
    const scrollToComponent = (targetComponent) => {
        targetComponent.scrollIntoView({
            behavior: 'smooth',
        });
    };
    window.addEventListener('hashchange', (event) => {
        const newUrl = new URL(event.newURL);
        navigateToHash(newUrl.hash.substring(1));
    });
    document.querySelectorAll('a[href^="#"]').forEach((link) => link.addEventListener('click', () => {
        const targetUrl = new URL(link.href);
        if (window.location.hash === targetUrl.hash) {
            navigateToHash(targetUrl.hash.substring(1));
        }
    }));
    if (window.location.hash !== '#' + window.firstPageIdentifier) {
        navigateToHash(window.location.hash.substring(1));
    }
};
